import React from 'react';
export function ArrowLeftRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M6.743 2.669L5.257 1.331.155 7l5.102 5.669 1.486-1.338-3.2-3.555L21 8V6l-17.456.224 3.2-3.555zm13.713 13.555l-3.2-3.555 1.487-1.338L23.845 17l-5.102 5.669-1.486-1.338 3.2-3.555L3 18v-2l17.456.224z"
  }));
}